import TableFoot from './TableFoot';
export default TableFoot;
